import React, {Component} from 'react'
import PropTypes from 'prop-types'
import CtaButton from './CtaButton'
import spinner from './images/spinner.gif'
import styles from './themes/default/styles.module.scss'

class SubmitButton extends Component {
  static propTypes = {
    formData: PropTypes.object,
    onClick: PropTypes.func,
    submitting: PropTypes.bool,
    validateOnly: PropTypes.array
  }

  static defaultProps = {
    formData: null,
    onClick: () => {},
    submitting: false,
    validateOnly: []
  }

  static displayName = 'SubmitButton'

  constructor(props) {
    super(props)

    this.state = {validated: false}

    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount() {
    this.updateState(this.props)
  }

  componentDidUpdate() {
    this.updateState(this.props)
  }

  hasErrors(props) {
    const {validateOnly, formData} = props,
      errors = formData ? formData.syncErrors : undefined,
      errorKeys = errors ? Object.keys(errors) : []

    if (validateOnly.length > 0) {
      return !!errorKeys.find(key => validateOnly.includes(key))
    } else {
      return errorKeys.length > 0
    }
  }

  updateState(props) {
    if (this.hasErrors(props)) {
      if (this.state.validated) {
        this.setState({validated: false})
      }
    } else if (!this.state.validated) {
      this.setState({validated: true})
    }
  }

  render() {
    const {formData, onClick, submitting, children, validateOnly, ...props} = this.props

    return (
      <CtaButton
        type="submit"
        disabled={!this.state.validated || submitting}
        onClick={this.handleClick}
        {...props}
      >
        {children} {submitting ? <img src={spinner} className={styles.spinner}/> : null}
      </CtaButton>
    )
  }

  handleClick(e, data) {
    const {onClick, formData} = this.props,
      {validated} = this.state

    if (validated) {
      onClick(e, data)
    } else {
      onClick(e, data, formData.syncErrors)
    }
  }
}

export default SubmitButton
